var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_7551_15580)",
    fillRule: "evenodd",
    d: "M27.821 21.587a5.44 5.44 0 0 1-3.36 1.532c-.857.073-1.971.118-3.205.143-.292.006-.566.12-.77.316l-1.306 1.293c.204-.196.479-.31.77-.316a53 53 0 0 0 3.206-.143 5.44 5.44 0 0 0 3.36-1.532z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_7551_15580)",
    fillRule: "evenodd",
    d: "M17.527 28.11a1.1 1.1 0 0 1-.812.326 1.15 1.15 0 0 1-.96-.549l-2.634-4.235c-.206-.33-.56-.54-.946-.562a54 54 0 0 1-3.332-.277 5.7 5.7 0 0 1-3.359-1.663 5.7 5.7 0 0 1-1.6-3.39l-.005-.038c-.025-.242-.05-.459-.072-.665-.126-1.114-.216-1.92-.216-4.667 0-2.607.081-3.284.197-4.241.028-.239.06-.494.091-.801l.004-.039a5.44 5.44 0 0 1 1.601-3.326L4.179 5.275a5.44 5.44 0 0 0-1.601 3.327l-.004.039c-.032.307-.063.562-.092.8-.115.958-.196 1.634-.196 4.242 0 2.747.09 3.553.215 4.667.023.206.048.423.073.665l.004.038a5.7 5.7 0 0 0 1.6 3.39 5.7 5.7 0 0 0 3.36 1.663c.887.11 2.048.203 3.332.277.385.022.74.232.945.562l2.635 4.235a1.17 1.17 0 0 0 .96.549 1.12 1.12 0 0 0 .811-.326z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_7551_15580)",
    d: "M18.62 18.023q-.316.081-.566.076-.534-.01-.752-.19-.216-.18-.216-.664 0-.194.067-.567a6 6 0 0 1 .151-.667l.687-2.417q.1-.332.138-.734.037-.4.037-.559 0-.769-.54-1.26-.538-.492-1.534-.511-.554-.011-1.172.174-.55.162-1.144.388a.3.3 0 0 0-.106.068l-1.306 1.292a.3.3 0 0 1 .107-.068q.594-.225 1.143-.388.619-.184 1.173-.173.995.02 1.534.51.54.493.54 1.26 0 .16-.038.56-.036.4-.138.733L16 17.304a6 6 0 0 0-.151.667 3.4 3.4 0 0 0-.067.566q0 .485.216.665.218.18.751.19.251.004.568-.077h.001c.187-.048.389.136.343.323l-.033.131a.3.3 0 0 1-.074.134l-.006.006.006-.006 1.299-1.286a.3.3 0 0 0 .08-.14l.032-.13c.047-.19-.156-.372-.344-.324"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear_7551_15580)",
    fillRule: "evenodd",
    d: "M18.812 8.713q.444-.427.443-1.038 0-.634-.48-1.095a1.66 1.66 0 0 0-1.157-.474 1.62 1.62 0 0 0-1.163.428L15.15 7.827q.484-.441 1.162-.428t1.157.473q.48.462.48 1.096 0 .61-.442 1.038z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint4_linear_7551_15580)",
    fillRule: "evenodd",
    d: "m29.422 7.809.004.039c.032.308.063.565.091.804.116.962.197 1.642.197 4.25 0 2.747-.09 3.548-.215 4.657-.024.206-.048.422-.073.662l-.004.04a5.44 5.44 0 0 1-1.601 3.326 5.44 5.44 0 0 1-3.36 1.532 53 53 0 0 1-3.205.143 1.14 1.14 0 0 0-.943.525l-2.638 4.138a1.1 1.1 0 0 1-.96.511 1.15 1.15 0 0 1-.96-.549l-2.635-4.235c-.205-.33-.56-.54-.945-.562a54 54 0 0 1-3.332-.277 5.7 5.7 0 0 1-3.36-1.663 5.7 5.7 0 0 1-1.6-3.39l-.004-.038c-.025-.242-.05-.459-.073-.665-.125-1.114-.215-1.92-.215-4.667 0-2.607.081-3.284.197-4.241.028-.239.059-.494.091-.801l.004-.039a5.44 5.44 0 0 1 1.6-3.326 5.44 5.44 0 0 1 3.36-1.532c1.862-.158 4.93-.196 7.81-.14 2.88.057 5.947.215 7.809.445a5.7 5.7 0 0 1 3.36 1.664 5.7 5.7 0 0 1 1.6 3.389m-10.669 10.87a.29.29 0 0 0 .18-.201l.032-.132c.047-.188-.156-.372-.344-.323a2.2 2.2 0 0 1-.568.076q-.533-.01-.751-.19-.216-.18-.216-.664-.001-.194.067-.567.066-.376.15-.667l.687-2.417q.102-.332.139-.734.037-.4.037-.56 0-.767-.54-1.26-.538-.49-1.534-.51-.554-.011-1.173.174-.549.162-1.143.388a.31.31 0 0 0-.193.218l-.024.098c-.051.21.154.4.362.342q.28-.079.548-.073.546.011.738.199t.193.656q0 .259-.063.57-.063.314-.155.662l-.69 2.427a7 7 0 0 0-.134.687 4 4 0 0 0-.042.597q0 .753.556 1.252.555.499 1.558.52.652.013 1.146-.15.449-.147 1.177-.418m.021-9.93q.48-.438.48-1.074 0-.634-.48-1.095a1.66 1.66 0 0 0-1.157-.474 1.62 1.62 0 0 0-1.162.428 1.4 1.4 0 0 0-.485 1.077q0 .635.485 1.092t1.163.47q.675.015 1.156-.425",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7551_15580",
    x1: 23.5,
    x2: 23.5,
    y1: 21.587,
    y2: 24.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#653D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F1C04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7551_15580",
    x1: 9.906,
    x2: 9.906,
    y1: 3.983,
    y2: 29.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#653D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F1C04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7551_15580",
    x1: 15.668,
    x2: 15.668,
    y1: 10.529,
    y2: 19.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#653D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F1C04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7551_15580",
    x1: 17.202,
    x2: 17.202,
    y1: 6.106,
    y2: 10.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#653D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F1C04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7551_15580",
    x1: 20.571,
    x2: 10.857,
    y1: 6.858,
    y2: 25.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0A174"
  })))));
};
export default SvgInfo;